/**
 * @file The Document AI word confidence below which a cited OCR word sends its
 * cell or pricebook page to review ("OCR confidence low" in the design doc's
 * route table). 0.85 is the number Mapping Review UI Spec v2 prints on every
 * OCR notice, schedules and scanned pricebook pages alike; revisit once the
 * harness measures where OCR misreads start. Shared: the server's
 * `checkOcrConfidence`, and S4's OCR notice, which counts the page's words
 * read below it.
 */
export const OCR_CONFIDENCE_REVIEW_THRESHOLD = 0.85;
